import PropTypes from "prop-types";
import { SpaceTitleWithEmoji } from "./SpaceTitleWithEmoji";

export const SpaceHeaderNoDropdown = ({
  space,
  shouldShowMembersCount = false,
}) => (
  <div className="flex items-center">
    <SpaceTitleWithEmoji
      space={space}
      shouldShowMembersCount={shouldShowMembersCount}
    />
  </div>
);

SpaceHeaderNoDropdown.propTypes = {
  space: PropTypes.shape({
    emoji: PropTypes.string,
    is_private: PropTypes.bool,
    name: PropTypes.string,
  }).isRequired,
  shouldShowMembersCount: PropTypes.bool,
};
